var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        title: _vm.$t("IVA_CONFIRM_PRICING_TITLE"),
        "confirm-action-text": _vm.$t("CONFIRM")
      },
      on: {
        close: function($event) {
          return _vm.$emit("confirm", false)
        },
        confirm: function($event) {
          return _vm.$emit("confirm", true)
        }
      }
    },
    [_c("p", [_vm._v("\n    " + _vm._s(_vm.$t("IVA_DESCRIPTION")) + "\n  ")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }